<template>
  <div class="card mb-3">
    <div class="card-header" :id="'heading' + index">
      <div class="mb-0">
        <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapse' + index" aria-expanded="true"
                :aria-controls="'collapse' + index">Prize Insurance</button>
        <button class="btn mt-1 font-size-small text-color-grey float-right">{{ dateCreated }}</button>
      </div>
    </div>
    <div :id="'collapse' + index" class="collapse" :aria-labelledby="'headingFour' + index" data-parent="#accordion">
      <div class="card-body d-md-flex flex-md-wrap">
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Company Name : </span>
          <span>{{ data.companyname }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Address : </span>
          <span>{{ data.address }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Phone Number : </span>
          <span>{{ data.phonenumber }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Email : </span>
          <span>{{ data.email }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Zip Code : </span>
          <span>{{ data.zipcode }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Name of Promotion Event : </span>
          <span>{{ data.namepromotionevent }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Description of Promotion Event : </span>
          <span>{{ data.descriptionpromotionevent }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Value to insure : </span>
          <span>{{ data.valueinsured }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Official Rules : </span>
          <span>{{ data.officialrules }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsuranceViewPrize',
  // Load props received from parent component to display insurance data
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    }
  },
  data () {
    return {
      dateCreated: null
    }
  },
  // convert date to a string using local settings
  created () {
    let date = new Date(this.data.created_on)
    this.dateCreated = date.toLocaleString()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/insurances/views/InsuranceViewPrize.vue